import React from 'react';

import doctorMenuItems from './doctorMenuItems';
import frontDeskMenuItems from './frontDeskMenuItems';

export default { doctorMenuItems, frontDeskMenuItems };
